// Removed incorrect import of Error icon
import { productApi } from "../api/ProductApi";
import { Category, Product, Station } from "../models/product/ProductModel";

class ProductManager {
  private static instance: ProductManager;

  public static get(): ProductManager {
    if (!this.instance) {
      this.instance = new ProductManager();
    }
    return this.instance;
  }

  async getAllProducts(): Promise<Product[] | undefined> {
    const result = await productApi.getAllProducts.requestHard(null);
    if (!result || !result.data) return [];
    return result.data.map((item: any) => new Product(item));
  }

  async updateOrCreateProduct(product: Product): Promise<boolean | undefined> {
    const result = await productApi.updateOrCreateProduct.request(product);
    return result.isSuccess;
  }

  async deleteProduct(product: Product): Promise<boolean | undefined> {
    const result = await productApi.deleteProduct.request(product);
    return result.isSuccess;
  }

  async getAllCategories(): Promise<Category[] | undefined> {
    const result = await productApi.getAllCategories.requestHard(null);
    if (!result || !result.data) return [];
    return result.data.map((item: any) => new Category(item));
  }

  async updateOrCreateCategory(
    category: Category
  ): Promise<boolean | undefined> {
    const result = await productApi.updateOrCreateCategory.request(category);
    return result.isSuccess;
  }

  async deleteCategory(category: Category): Promise<boolean | undefined> {
    const result = await productApi.deleteCategory.request(category);
    return result.isSuccess;
  }

  async getAllStations(): Promise<Station[] | undefined> {
    const result = await productApi.getAllStations.requestHard(null);
    if (!result || !result.data) return [];
    return result.data.map((item: any) => new Station(item));
  }

  async updateOrCreateStation(station: Station): Promise<boolean | undefined> {
    const result = await productApi.updateOrCreateStation.request(station);
    return result.isSuccess;
  }

  async deleteStation(station: Station): Promise<boolean | undefined> {
    const result = await productApi.deleteStation.request(station);
    return result.isSuccess;
  }
}

export const productManager = ProductManager.get();
